// extracted by mini-css-extract-plugin
module.exports = {"header":"block-view__headerLni","content":"block-view__content19Q","button":"block-view__button35L"};